import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {ItemModule} from "../../../../../core/component/item/item.module";
import {SummaryFieldModule} from "../../../../../core/component/summary-field/summary-field.module";
import {PriceSummaryFieldComponent} from "./price-summary-field.component";
import {PriceLabelModule} from "../price-label/price-label.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ItemModule,
        SummaryFieldModule,
        PriceLabelModule
    ],
    declarations: [
        PriceSummaryFieldComponent,
    ],
    exports: [
        PriceSummaryFieldComponent
    ],
})
export class PriceSummaryFieldModule {
}